import React, { useState, useEffect, useCallback } from 'react';
import usePeopleData from 'hooks/usePeopleData';
import useCompanies from 'hooks/useCompanies';
import CompanyPeopleDropdownBase from './components/DropdownBase';
import formatCompanyPeopleOptions from './helpers/format-company-people-options';
import {
  CompanyPeopleDropdownWithHooksProps,
  CompanyPeopleItem,
  DropdownGroupItem
} from './types';

/**
 * CompanyPeopleDropdown component that loads data using hooks
 */
const CompanyPeopleDropdown: React.FC<CompanyPeopleDropdownWithHooksProps> = ({
  value,
  onChange,
  id,
  bottomButtonText,
  bottomButtonIcon,
  title,
  hidePeople,
  hideCompanies,
  allowSearch,
  defaultDrawerType,
  disableDrawerTypeChange,
  hideIcon
}) => {
  const [mixedItems, setMixedItems] = useState<DropdownGroupItem[]>([]);

  const { people, loadPeople } = usePeopleData();
  const { companies, loadCompanies } = useCompanies();

  useEffect(() => {
    const formattedItems = formatCompanyPeopleOptions({
      people,
      companies,
      hidePeople,
      hideCompanies
    });
    setMixedItems(formattedItems);
  }, [people, companies, hidePeople, hideCompanies]);

  const handleCompanyPeopleChange = useCallback(
    (item: CompanyPeopleItem | null) => {
      if (onChange) {
        onChange(item);
      }

      if (!hidePeople) {
        loadPeople();
      }

      if (!hideCompanies) {
        loadCompanies();
      }
    },
    [onChange, hidePeople, hideCompanies, loadPeople, loadCompanies]
  );

  return (
    <CompanyPeopleDropdownBase
      bottomButtonText={bottomButtonText}
      bottomButtonIcon={bottomButtonIcon}
      onChange={handleCompanyPeopleChange}
      value={value}
      id={id}
      title={title}
      allowSearch={allowSearch}
      items={mixedItems}
      defaultDrawerType={defaultDrawerType}
      disableDrawerTypeChange={disableDrawerTypeChange}
      hideIcon={hideIcon}
    />
  );
};

export default CompanyPeopleDropdown;
